type Field = {
  content: React.ReactNode;
  key: 'issueKey' | 'summary' | 'severityLevel' | 'status' | 'issueCreated';
  width?: number;
  shouldTruncate?: boolean;
};

export const fields: Field[] = [
  {
    content: 'Ticket',
    key: 'issueKey',
    width: 15,
  },
  {
    content: 'Summary',
    key: 'summary',
    width: 30,
  },
  {
    content: 'Severity',
    key: 'severityLevel',
    shouldTruncate: true,
    width: 10,
  },
  {
    content: 'Created',
    key: 'issueCreated',
    shouldTruncate: true,
    width: 10,
  },
  {
    content: 'Status',
    key: 'status',
    width: 10,
  },
];
const keys = ['status', 'issueKey', 'severityLevel', 'summary'];

export const compactFields = fields
  .filter(field => keys.includes(field.key))
  .map(({ key, ...other }) => {
    if (key === 'issueKey') {
      return {
        ...other,
        key,
        width: 15,
      };
    }
    if (key === 'summary') {
      return {
        ...other,
        key,
        width: 22,
      };
    }
    return {
      key,
      ...other,
    };
  });
